export default function () {
  if (document.getElementById('favorite-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "favorite-offers-app" */ '../../_03_organisms/offer/favorite/main'
    );
  }
}
